/**
 * @param {string | undefined} [className]
 * @returns {React.ReactElement}
 */
const CompanyLogoHelios = ({ className }) => (
  <svg
    version="1.1"
    className={className}
    x="0px"
    y="0px"
    width="1567.56px"
    height="370.205px"
    viewBox="0 0 1567.56 370.205"
  >
    <g id="Logo">
      <g>
        <g>
          <g>
            <g>
              <path
                style={{ fill: '#63B64D' }}
                d="M562.646,236.415H429.039v111.732c0,1.117-0.912,2.037-2.029,2.037h-61.566
								c-1.119,0-2.023-0.92-2.023-2.037V68.764c0-1.105,0.905-2.018,2.023-2.018h61.566c1.117,0,2.029,0.912,2.029,2.018v107.722
								h133.607V68.764c0-1.105,0.909-2.018,2.034-2.018h61.164c1.124,0,2.027,0.912,2.027,2.018v279.384
								c0,1.117-0.903,2.037-2.027,2.037h-61.164c-1.125,0-2.034-0.92-2.034-2.037V236.415z"
              />
              <path
                style={{ fill: '#63B64D' }}
                d="M910.865,59.044l57.087-15.07c1.3-0.34,2.559,0.629,2.559,1.959v302.189
								c0,1.115-0.907,2.035-2.029,2.035h-57.1c-1.121,0-2.025-0.92-2.025-2.035V61.02
								C909.356,60.097,909.976,59.283,910.865,59.044z"
              />
              <path
                style={{ fill: '#63B64D' }}
                d="M1061.588,114.535c-20.056,0-35.467-14.658-35.467-33.553
								c0-19.264,15.411-33.511,35.467-33.511c20.045,0,35.423,14.247,35.423,33.511
								C1097.011,99.877,1081.633,114.535,1061.588,114.535z M1032.862,143.296h57.054c1.122,0,2.034,0.907,2.034,2.024v202.802
								c0,1.115-0.912,2.035-2.034,2.035h-57.054c-1.139,0-2.044-0.92-2.044-2.035V145.32
								C1030.818,144.203,1031.724,143.296,1032.862,143.296z"
              />
              <path
                style={{ fill: '#63B64D' }}
                d="M1247.63,137.628c70.459,0,111.757,52.214,111.757,108.47
								c0,57.103-43.751,109.718-112.155,109.718c-70.057,0-111.726-52.615-111.726-108.877
								C1135.506,190.271,1179.215,137.628,1247.63,137.628z M1195.433,247.816c0,32.544,22.286,56.931,52.266,56.931
								c31.163,0,52.662-25.639,52.662-57.755c0-32.533-22.295-56.524-52.264-56.524
								C1216.933,190.468,1195.433,215.653,1195.433,247.816z"
              />
              <path
                style={{ fill: '#63B64D' }}
                d="M1478.09,354.628c-35.161,0-62.264-11.51-85.296-24.625c-1.938-1.09-3.96-3.254-3.566-5.258
								l9.061-43.643c0.157-0.988,0.873-1.766,1.829-1.143c26.229,17.207,49.416,29.303,81.578,29.303
								c17.818,0,28.752-6.852,28.752-16.609c0-10.926-8.095-15.756-45.345-25.49c-42.08-10.941-72.081-25.082-72.081-63.977
								c0-37.24,32.403-64.344,87.068-64.344c28.245,0,50.896,7.021,68.603,15.797c2.429,1.205,4.213,3.998,3.9,6.418l-8.457,40.677
								c-0.266,1.283-1.395,2.044-2.507,1.377c-20.754-12.709-46.567-19.34-63.942-19.34c-18.233,0-27.965,6.499-27.965,15.4
								c0,10.491,9.309,14.946,44.126,23.858c46.999,11.735,73.32,26.305,73.32,66.395
								C1567.168,327.497,1532.749,354.628,1478.09,354.628z"
              />
              <path style={{ fill: '#4EAE3A' }} d="M907.012,194.605" />
              <path style={{ fill: '#4EAE3A' }} d="M609.646,275.792" />
              <path
                style={{ fill: '#63B64D' }}
                d="M866.056,223.931c-0.022-0.164,0.027-0.282-0.011-0.45c-0.065-0.303-0.175-0.688-0.239-0.997
								c-1.876-9.423-4.762-18.542-7.757-25.107l-0.037,0.017c-0.798-2.034-1.591-4.035-2.345-5.695
								c-14.408-31.69-42.877-54.069-87.107-54.069c-63.154,0-104.877,50.602-104.877,108.47c0,65.218,42.905,108.53,110.56,108.53
								c28.95,0,49.875-7.037,69.901-16.379c1.812-0.846,3.208-2.441,3.821-4.336l10.262-49.125
								c0.794-2.703-0.757-4.639-2.461-3.766c-18.314,11.664-41.864,25.623-70.615,25.402
								c-29.089-0.209-52.844-12.154-60.312-32.639l136.921-36.434c4.021-1.406,5.838-3.663,5.35-7.368
								C866.843,227.967,866.435,225.942,866.056,223.931z M765.377,181.759c16.794-1.074,37.067,9.091,43.95,26.756l-91.418,24.421
								C716.711,199.969,741.394,183.307,765.377,181.759z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                style={{ fill: '#216B4A' }}
                d="M241.845,140.65c-4.376-21.553-10.198-35.37-26.554-33.06
								c-12.032,1.704-17.207,12.781-16.003,25.72c3.563,36.737,5.723,71.337-3.592,108.011
								c-4.084,16.066-13.132,60.988-41.869,52.156c-20.847-6.396-16.486-34.16-15.292-48.596
								c4.317-30.266-5.686-36.952-14.854-38.489c-12.693-2.132-22.317,4.117-26.462,28.771
								c-1.692,7.966-15.537,74.153-16.209,80.952c-1.91,19.621,5.078,40.773,6.494,45.693c0.481,1.766,1.675,2.939,3.434,3.357
								c43.452,9.195,88.88,6.039,121.672-13.172c1.806-1.059,2.761-2.305,3.624-3.428c18.129-26.137,26.364-65.971,30.774-96.989
								C252.234,214.84,250.394,176.795,241.845,140.65z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                style={{ fill: '#63B64D' }}
                d="M8.465,229.54c4.388,21.558,10.209,35.387,26.559,33.064
								c12.032-1.703,17.197-12.781,16.014-25.713c-3.569-36.732-5.739-71.343,3.581-108.009
								c4.084-16.062,13.127-60.98,41.874-52.153c20.843,6.385,16.486,34.171,15.298,48.596
								c-4.339,30.252,5.675,36.965,14.843,38.488c12.693,2.139,22.322-4.113,26.456-28.796c1.699-7.946,15.549-74.14,16.216-80.947
								c1.909-19.605-5.079-40.769-6.495-45.683c-0.478-1.759-1.671-2.93-3.434-3.347c-43.452-9.2-88.875-6.039-121.663,13.16
								c-1.816,1.046-2.771,2.316-3.633,3.434C15.951,47.777,7.715,87.61,3.311,118.636C-1.919,155.361-0.074,193.407,8.465,229.54z
								"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CompanyLogoHelios;
